import { getItem, removeItem, setItem } from '@ms/yammer-session-storage';

import { yammerNamespace } from './telemetryStore';

interface NamespacedStorageValue<T> {
  readonly get: () => T;
  readonly set: (value: T) => void;
  readonly remove: () => void;
}

type CreateNamespacedStorageValue = <T>(keySuffix: string, getDefaultValue: () => T) => NamespacedStorageValue<T>;

export const createNamespacedStorageValue: CreateNamespacedStorageValue = <T>(
  keySuffix: string,
  getDefaultValue: () => T
) => {
  const key = `${yammerNamespace}.${keySuffix}`;

  return {
    get: () => getItem<T>(key) ?? getDefaultValue(),
    set: (value: T) => {
      setItem<T>(key, value);
    },
    remove: () => {
      removeItem(key);
    },
  };
};
